import WorkspaceRouteComponent from "@/components/shared/WorkspaceRouteComponent";
import {State} from "@/types/Workflow";
import Instance from "@/types/Instance";
import {Component} from "vue-facing-decorator";
import Idea from "@/types/Idea";

@Component
class WorkflowLevelRouteComponent extends WorkspaceRouteComponent {

    get workflow() {
        const workflowAlias = this.params.workflow
        return this.workspace.workflowWith(workflowAlias)!
    }

    async updateCurrentWorkflow(changes: any) {
        return this.updateWorkflow(this.workflow, changes)
    }

    async deleteCurrentWorkflow() {
        return this.deleteWorkflow(this.workflow)
    }
}

export default WorkflowLevelRouteComponent
